import React from "react";
import DropdownWrapper from "./DropdownWrapper";
import NestedMenu from './NestedMenu';


const DesktopHeaderDropdown = ({ items = [], ctas = [], menuID, openMenuID, storeLink, labels }) => {
	if ((!items || !items.length) && (!ctas || !ctas.length)) return null;
	
	return (
		<DropdownWrapper menuID={menuID} openMenuID={openMenuID}>
			<NestedMenu items={items} ctas={ctas} storeLink={storeLink} labels={labels} />
		</DropdownWrapper>
	);
};
export default (DesktopHeaderDropdown);
